import React from 'react';
import { Modal } from 'semantic-ui-react';
import ModalBase from '../ModalBase';
import styles from './signature-modal.less';

interface SignatureModalProps {
  visible: boolean;
  onClose: () => void;
  signature: string;
}

export const SignatureModal = ({ visible, onClose, signature }: SignatureModalProps) => {
  return (
    <Modal size="small" open={visible}>
      <ModalBase header="Signature" onAccept={async () => onClose()} actionWord="Ok">
        <div className={styles.signature_container}>
          <img src={signature} alt="Signature" className={styles.signature_image} />
        </div>
      </ModalBase>
    </Modal>
  );
};
